<template>
    <form class="auth-form" @submit.prevent="update" @keydown="form.onKeydown($event)">
        <div v-if="user.account_type === 'business'" class="form-row">
            <div class="form-group col-sm-12">
                <label class="required">Business Name</label>
                <input v-model="form.business_name" :class="{ 'is-invalid': form.errors.has('business_name') }" type="text" name="business_name" class="form-control">
                <has-error :form="form" field="business_name"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-sm-12">
                <label class="required">Address</label>
                <input v-model="form.address" :class="{ 'is-invalid': form.errors.has('address') }" type="text" name="address" class="form-control">
                <has-error :form="form" field="address"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-sm-12">
                <label class="required">Suburb</label>
                <input v-model="form.suburb" :class="{ 'is-invalid': form.errors.has('suburb') }" type="text" name="suburb" class="form-control">
                <has-error :form="form" field="suburb"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-sm-12 col-md-8">
                <label class="required">City</label>
                <input v-model="form.city" :class="{ 'is-invalid': form.errors.has('city') }" type="text" name="city" class="form-control">
                <has-error :form="form" field="city"/>
            </div>
            <div class="form-group col-sm-12 col-md-4">
                <label class="required">Postcode</label>
                <input v-model="form.postcode" :class="{ 'is-invalid': form.errors.has('postcode') }" type="text" name="postcode" class="form-control">
                <has-error :form="form" field="postcode"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-sm-12">
                <label>Country</label>
                <b-form-select v-model="form.country" :options="countries" :class="{ 'is-invalid': form.errors.has('country') }" name="country" class="form-control"/>
                <has-error :form="form" field="country"/>
            </div>
        </div>

        <div v-if="showSubmit" class="form-group">
            <v-button :loading="form.busy">
                Save billing info
            </v-button>
        </div>
    </form>
</template>
<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
    name: 'BillingForm',
    props: {
        showSubmit: {
            default: true,
            type: Boolean
        }
    },
    data: () => ({
        countries: [],
        accountTypes: [
            {
                value: 'personal',
                text: 'Personal'
            },
            {
                value: 'business',
                text: 'Business'
            }
        ],
        form: new Form({
            account_type: 'individual',
            business_name: '',
            address: '',
            phone: '',
            suburb: '',
            city: '',
            postcode: ''
        })
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    async created () {
        await axios.get('/countries?format=select')
            .then(rsp => rsp.data)
            .then((rsp) => {
                this.countries = rsp.data
            })
    },
    mounted () {
        this.form.business_name = this.user.business_name
        this.form.address = this.user.address
        this.form.phone = this.user.phone
        this.form.suburb = this.user.suburb
        this.form.city = this.user.city
        this.form.postcode = this.user.postcode
        this.form.country = this.user.country.id
        this.form.account_type = this.user.account_type
    },
    methods: {
        async update () {
            await this.form.patch('/account/billing').then(rsp => rsp.data)
                .then((rsp) => {
                    this.$store.dispatch('auth/updateUser', { user: rsp })

                    this.$emit('billing-updated')
                }).catch((e) => {
                })

            return this.form.successful
        }
    }
}
</script>
